import {
  fetchInstanceData,
  FetchInstanceOptions,
} from '@/src/core/dicom-web-api';
import { DataLoader, MetaLoader } from '@/src/core/streaming/types';

export class DicomWebInstanceMetaLoader implements MetaLoader {
  meta: Array<[string, string]>;
  metaBlob = null;

  constructor(tags: Array<[string, string]>) {
    this.meta = tags;
  }

  load() {}
  stop() {}
}

export class DicomWebInstanceDataLoader implements DataLoader {
  data: Blob | null = null;

  constructor(
    private root: string,
    private instance: FetchInstanceOptions
  ) {}

  async load() {
    this.data = await fetchInstanceData(this.root, this.instance);
  }

  stop() {}

  release() {
    this.data = null;
  }
}
